import { render, staticRenderFns } from "./seckilllDetail.vue?vue&type=template&id=65a0b9a1&scoped=true&"
import script from "./seckilllDetail.vue?vue&type=script&lang=js&"
export * from "./seckilllDetail.vue?vue&type=script&lang=js&"
import style0 from "./seckilllDetail.vue?vue&type=style&index=0&id=65a0b9a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0b9a1",
  null
  
)

export default component.exports